// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1s9-s","noInteraction":"EventWrapper_noInteraction__36TM2"};